import { trimEnd } from 'lodash';

export const getLinkToUserWallet = (hash: string): string => {
  return `${trimEnd(process.env.VUE_APP_EXPLORER_URL, '/')}/user/${hash}`;
};

export const getLinkToGameTransaction = (hash: string): string => {
  return `${trimEnd(
    process.env.VUE_APP_EXPLORER_URL,
    '/'
  )}/transaction/tx${hash.replace(/-/g, '')}`;
};
